import { useCallback, useState } from "react";

export const PRECIP_KEY = "divespots.map.precip";

/** Off unless this device turned it on; storage may be missing or throw (private mode). */
export function readPrecipPref(): boolean {
  try {
    return localStorage.getItem(PRECIP_KEY) === "on";
  } catch {
    return false;
  }
}

export function writePrecipPref(on: boolean): void {
  try {
    if (on) localStorage.setItem(PRECIP_KEY, "on");
    else localStorage.removeItem(PRECIP_KEY);
  } catch {
    /* the choice just is not remembered */
  }
}

/** The precipitation switch, remembered per device (independent of the wind switch). */
export function usePrecipPref(): [boolean, (on: boolean) => void] {
  const [on, setOn] = useState(readPrecipPref);
  const set = useCallback((v: boolean) => {
    setOn(v);
    writePrecipPref(v);
  }, []);
  return [on, set];
}
